import {
  CLEAR_CONFIG_SUCCESS,
  IMPORT_APIDAE_DATA_SUCCESS,
  GET_ACCOMODATION_OPTIONS_SUCCESS,
  GET_ACCOMODATION_IMAGES_SUCCESS,
  GET_ACCOMODATION_ROOMS_SUCCESS,
  GET_ACCOMODATION_MEALPLANS_SUCCESS,
  CHANGE_LANG_SUCCESS
} from "../../actions";

const ACCOMODATION_SHAPE = {
  lang: "fr"
};

export default (state = ACCOMODATION_SHAPE, action) => {
  switch (action.type) {
    case CLEAR_CONFIG_SUCCESS: {
      return ACCOMODATION_SHAPE;
    }

    case IMPORT_APIDAE_DATA_SUCCESS: {
      return {
        ...state,
        ...action.config
      };
    }

    case GET_ACCOMODATION_OPTIONS_SUCCESS: {
      return { ...state, accomodationOptions: action.accomodationOptions };
    }

    case GET_ACCOMODATION_IMAGES_SUCCESS: {
      return { ...state, images: action.images };
    }

    case GET_ACCOMODATION_ROOMS_SUCCESS: {
      return { ...state, rooms: action.rooms };
    }

    case GET_ACCOMODATION_MEALPLANS_SUCCESS: {
      return { ...state, mealplans: action.mealplans };
    }

    case CHANGE_LANG_SUCCESS: {
      return { ...state, lang: action.lang };
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/merchant/accomodation/reducers.js